import { IBillingSubscription } from '../entities/Billing/Billing';
import { IState } from '../reducers';
import { Http } from '../tools/http';
import { action } from '../tools/reduxTools';

export const getBillingSubscriptions = () => action<Promise<IBillingSubscription[]>>(async (dispatch, getState: () => IState, http: Http) => {
    return http.commonApiGet(`/subscriptions`);
});